import React from "react";
import { PlanCardLoaderTemplate } from "themes/application/payment/components";

function PlanCardLoader(props) {
    return <PlanCardLoaderTemplate {...props} />;
}

export default PlanCardLoader;
